/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AdminOverride } from './adminOverride';

export type GradingAdminOverride = AdminOverride | null;
